import React from 'react'
import { Box, Typography, Grid, Stack, Link } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'

import imgType1 from '@assets/images/sub/img_license_1.svg'
import imgType2 from '@assets/images/sub/img_license_2.svg'
import imgType3 from '@assets/images/sub/img_license_3.svg'
import imgType4 from '@assets/images/sub/img_license_4.svg'
import imgOpen from '@assets/images/sub/img_license_open.png'

export default function LicenseGuideSection() {
  const { isMobile } = useIsMobile()

  const items = [
    { title: '제1유형', img: imgType1, desc: '출처표시' },
    { title: '제2유형', img: imgType2, desc: '출처표시+상업용금지' },
    { title: '제3유형', img: imgType3, desc: '출처표시+변경금지' },
    { title: '제4유형', img: imgType4, desc: '출처표시+상업용금지+변경금지' },
  ]

  return (
    <Box>
      <Typography>
        저작권법 제24조의2(공공저작물의 자유이용)에 따라 OpenVLab에서는 저작재산권의 전부를 보유하고 있거나 자유이용허락표시에 대한 권리자의 동의를 받은 경우는 “공공저작물 자유이용허락표시기준(OpenVLab)”을 부착하여 별도의 이용허락 없이 자유이용이 가능합니다.
      </Typography>

      {/* 카드 */}
      <Grid container columnSpacing={isMobile ? 1 : 5} rowSpacing={isMobile ? 1 : 'initial'} sx={{ my: isMobile ? 5 : 10 }}>
        {items.map((it, idx) => (
          <Grid item xs={6} md={3} key={idx}>
            <Box
              sx={{
                p: isMobile ? 1 : 3,
                borderRadius: isMobile ? 4 : '50%',
                textAlign: 'center',
                bgcolor: 'grey.50',
                aspectRatio: 1 / 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Stack spacing={isMobile ? 1 : 2} alignItems="center">
                <Typography variant={isMobile ? 'body1' : 'subtitle2'} fontWeight={700}>
                  {it.title}
                </Typography>
                <Box
                  component="img"
                  src={it.img}
                  alt={it.title}
                  sx={{
                    width: '100%',
                    maxWidth: isMobile ? '120px' : '200px',
                  }}
                />
                <Typography variant={isMobile ? 'body3' : 'body1'} color="text.secondary">{it.desc}</Typography>
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Stack spacing={1.5}>
        <Typography>
          단, 위 규정에 따라 “공공저작물 자유이용허락표시기준(OpenVLab)”이 부착된 공공저작물은 제1유형의 경우 출처표시만 하면 자유이용이 가능하나, 제2유형은 상업적 이용을, 제3유형은 변경 이용을,  제4유형은 상업적 이용과 변경 이용을 금지하고 있으니, 반드시 그 이용조건을 확인하신 후 해당 이용조건의 범위 안에서 이용하시기 바랍니다.
        </Typography>

        <Typography>
          또한 제1유형을 포함하여 어느 유형이든 출처(발행연도, 기관명과 홈페이지 URL, 저작물 작성자의 성명이 표시된 경우에는 그 성명도 포함)는 반드시 표시하여야 함을 유의하시기 바랍니다. 출처 표기는 아래의  예시를 참고 하시기 바랍니다.
        </Typography>

        <Typography 
          component="div"
          variant="body2"
          fontWeight={600}
          color="text.secondary"
          sx={{
            position: 'relative',
            pl: '1em',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '8px',
              width: '4px',
              height: '4px',
              borderRadius: '50%',
              bgcolor: 'grey.600',
            },
          }}
        >
          출처 활용예시
          <Typography variant="body2" color="text.secondary">
            본 저작물은 ‘OpenVLab’에서 ‘2025년’ 작성하여 OpenVLab 제1유형으로 개방한 ‘저작물명(작성자:홍길동)’을 이용하였으며, 해당 저작물은 ‘OpenVLab, www.openvlab.kr’에서 무료로 다운받으실 수 있습니다.
          </Typography>
        </Typography>

        <Typography sx={{ pt: 2.5 }}>
          아래 표시가 적용된 저작물은 저작권 보호기간이 만료되어 별도 이용조건(출처표시 포함)이 없는 공공저작물이므로 저작물 이용에 참고하시기 바랍니다.
        </Typography>
      </Stack>

      <Stack direction={isMobile ? 'column' : 'row'} alignItems="center" spacing={3} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: isMobile ? 2 : 4, mt: 1.5 }}>
        <Box
          component="img"
          src={imgOpen}
          alt="open license"
          sx={{ flexShrink: 0 }}
        />

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              height: '64px',
              bgcolor: 'divider',
            }}
          />
        )}

        <Box>
          <Typography>
            별도표기가 부착되지 않은 자료들을 이용하고자 할 경우에는 관련 담당자와 사전에 협의하여 이용해 주시기 바랍니다.
          </Typography>

          <Stack direction={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'} spacing={isMobile ? 1 : 4} sx={{ mt: 1 }}>
            <Stack direction="row" alignItems="center" spacing={isMobile ? 0.5 : 1}>
              <Typography variant={isMobile ? 'body2' : 'body1'} fontWeight={500}>
                OpenVLab 구축 사업단
              </Typography>

              <Box
                sx={{
                  width: '1px',
                  height: '16px',
                  bgcolor: 'divider',
                }}
              />

              <Typography variant={isMobile ? 'body2' : 'body1'}>
                <Link
                  href="mailto:openvlab@knou.ac.kr"
                  sx={{
                    textDecoration: 'underline',
                    color: 'primary.main',
                    '&:hover': {
                      color: 'primary.main',
                    },
                    '&::after': {
                      content: '""',
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      width: '18px',
                      height: '18px',
                      ml: 0.5,
                      backgroundSize: 'cover',
                      backgroundImage:
                        'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'32\' height=\'32\' viewBox=\'0 0 32 32\' fill=\'none\'%3E%3Crect x=\'4.8\' y=\'7.8\' width=\'22.4\' height=\'15.4\' rx=\'2.2\' stroke=\'%23FA6700\' stroke-width=\'1.6\'/%3E%3Cpath d=\'M6 9L13.886 16.1819C15.0209 17.2155 16.7529 17.2256 17.8999 16.2054L26 9\' stroke=\'%23FA6700\' stroke-width=\'1.6\' stroke-linecap=\'round\'/%3E%3Cline x1=\'5.50885\' y1=\'22.3685\' x2=\'14.1917\' y2=\'15.6152\' stroke=\'%23FA6700\' stroke-width=\'1.6\'/%3E%3Cline y1=\'-0.8\' x2=\'11\' y2=\'-0.8\' transform=\'matrix(-0.789352 -0.613941 -0.613941 0.789352 25.8926 23)\' stroke=\'%23FA6700\' stroke-width=\'1.6\'/%3E%3C/svg%3E")',
                    },
                  }}
                >
                  openvlab@knou.ac.kr
                </Link>
              </Typography>
            </Stack>

            {/* <Stack direction="row" alignItems="center" spacing={isMobile ? 0.5 : 1}>
              <Typography variant={isMobile ? 'body2' : 'body1'} fontWeight={500}>
                공공저작물 관리책임관
              </Typography>

              <Box
                sx={{
                  width: '1px',
                  height: '16px',
                  bgcolor: 'divider',
                }}
              />

              <Typography variant={isMobile ? 'body2' : 'body1'}>
                000팀장(02-0000-0000)
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={isMobile ? 0.5 : 1}>
              <Typography variant={isMobile ? 'body2' : 'body1'} fontWeight={500}>
                공공저작물 실무담당자
              </Typography>

              <Box
                sx={{
                  width: '1px',
                  height: '16px',
                  bgcolor: 'divider',
                }}
              />

              <Typography variant={isMobile ? 'body2' : 'body1'}>
                000팀원(02-0000-0000)
              </Typography>
            </Stack> */}
          </Stack>
        </Box>
      </Stack>
    </Box>
  )
}
